import {
  Component,
  forwardRef,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FinancialProductWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/financial-product-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-financial-product-desktop',
  templateUrl: './financial-product-desktop.component.html',
  styleUrls: ['./financial-product-desktop.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinancialProductDesktopComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FinancialProductDesktopComponent),
      multi: true,
    },
  ],
})
export class FinancialProductDesktopComponent extends FinancialProductWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
  }
}
